/* eslint-disable */
tinymce.addI18n('it', {
  Redo: 'Ripeti',
  Undo: 'Indietro',
  Cut: 'Taglia',
  Copy: 'Copia',
  Paste: 'Incolla',
  'Select all': 'Seleziona Tutto',
  'New document': 'Nuovo Documento',
  Ok: 'Ok',
  Cancel: 'Annulla',
  'Visual aids': 'Elementi Visivi',
  Bold: 'Grassetto',
  Italic: 'Corsivo',
  Underline: 'Sottolineato',
  Strikethrough: 'Barrato',
  Superscript: 'Apice',
  Subscript: 'Pedice',
  'Clear formatting': 'Cancella Formattazione',
  'Align left': 'Allinea a Sinistra',
  'Align center': 'Allinea al Cento',
  'Align right': 'Allinea a Destra',
  Justify: 'Giustifica',
  'Bullet list': 'Elenchi Puntati',
  'Numbered list': 'Elenchi Numerati',
  'Decrease indent': 'Riduci Rientro',
  'Increase indent': 'Aumenta Rientro',
  Close: 'Chiudi',
  Formats: 'Formattazioni',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Il tuo browser non supporta l'accesso diretto negli Appunti. Per favore usa i tasti di scelta rapida Ctrl+X/C/V.",
  Headers: 'Intestazioni',
  'Header 1': 'Intestazione 1',
  'Header 2': 'Header 2',
  'Header 3': 'Intestazione 3',
  'Header 4': 'Intestazione 4',
  'Header 5': 'Intestazione 5',
  'Header 6': 'Intestazione 6',
  Headings: 'Intestazioni',
  'Heading 1': 'Intestazione 1',
  'Heading 2': 'Intestazione 2',
  'Heading 3': 'Intestazione 3',
  'Heading 4': 'Intestazione 4',
  'Heading 5': 'Intestazione 5',
  'Heading 6': 'Intestazione 6',
  Preformatted: 'Preformattato',
  Div: 'Div',
  Pre: 'Pre',
  Code: 'Codice',
  Paragraph: 'Paragrafo',
  Blockquote: 'Blockquote',
  Inline: 'Inlinea',
  Blocks: 'Blocchi',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.':
    "Incolla \u00e8 in modalit\u00e0 testo normale. I contenuti sono incollati come testo normale se non disattivi l'opzione.",
  'Font Family': 'Famiglia font',
  'Font Sizes': 'Dimensioni font',
  Class: 'Classe',
  'Browse for an image': "Scegli un'immagine",
  OR: 'o',
  'Drop an image here': "Incolla un'immagine qui",
  Upload: 'Carica',
  Block: 'Blocco',
  Align: 'Allinea',
  Default: 'Default',
  Circle: 'Cerchio',
  Disc: 'Disco',
  Square: 'Quadrato',
  'Lower Alpha': 'Alpha Minore',
  'Lower Greek': 'Greek Minore',
  'Lower Roman': 'Roman Minore',
  'Upper Alpha': 'Alpha Superiore',
  'Upper Roman': 'Roman Superiore',
  Anchor: 'Fissa',
  Name: 'Nome',
  Id: 'Id',
  'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.':
    "L'id dovrebbe cominciare con una lettera, seguito solo da lettere, numeri, linee, punti, virgole.",
  'You have unsaved changes are you sure you want to navigate away?':
    'Non hai salvato delle modifiche, sei sicuro di andartene?',
  'Restore last draft': "Ripristina l'ultima bozza.",
  'Special character': 'Carattere Speciale',
  'Source code': 'Codice Sorgente',
  'Insert/Edit code sample': 'Inserisci/Modifica esempio di codice',
  Language: 'Lingua',
  'Code sample': 'Esempio di codice',
  Color: 'Colore',
  R: 'R',
  G: 'G',
  B: 'B',
  'Left to right': 'Da Sinistra a Destra',
  'Right to left': 'Da Destra a Sinistra',
  Emoticons: 'Emoction',
  'Document properties': 'Propriet\u00e0 Documento',
  Title: 'Titolo',
  Keywords: 'Parola Chiave',
  Description: 'Descrizione',
  Robots: 'Robot',
  Author: 'Autore',
  Encoding: 'Codifica',
  Fullscreen: 'Schermo Intero',
  Action: 'Azione',
  Shortcut: 'Scorciatoia',
  Help: 'Aiuto',
  Address: 'Indirizzo',
  'Focus to menubar': 'Focus sulla barra del menu',
  'Focus to toolbar': 'Focus sulla barra degli strumenti',
  'Focus to element path': "Focus sul percorso dell'elemento",
  'Focus to contextual toolbar': 'Focus sulla barra degli strumenti contestuale',
  'Insert link (if link plugin activated)': 'Inserisci link (se il plugin link \u00e8 attivato)',
  'Save (if save plugin activated)': 'Salva (se il plugin save \u00e8 attivato)',
  'Find (if searchreplace plugin activated)': 'Trova (se il plugin searchreplace \u00e8 attivato)',
  'Plugins installed ({0}):': 'Plugin installati ({0}):',
  'Premium plugins:': 'Plugin Premium:',
  'Learn more...': 'Per saperne di pi\u00f9...',
  'You are using {0}': 'Stai usando {0}',
  Plugins: 'Plugin',
  'Handy Shortcuts': 'Scorciatoia pratica',
  'Horizontal line': 'Linea Orizzontale',
  'Insert/edit image': 'Aggiungi/Modifica Immagine',
  'Image description': 'Descrizione Immagine',
  Source: 'Fonte',
  Dimensions: 'Dimenzioni',
  'Constrain proportions': 'Mantieni Proporzioni',
  General: 'Generale',
  Advanced: 'Avanzato',
  Style: 'Stile',
  'Vertical space': 'Spazio Verticale',
  'Horizontal space': 'Spazio Orizzontale',
  Border: 'Bordo',
  'Insert image': 'Inserisci immagine',
  Image: 'Immagine',
  'Image list': 'Elenco immagini',
  'Rotate counterclockwise': 'Ruota in senso antiorario',
  'Rotate clockwise': 'Ruota in senso orario',
  'Flip vertically': 'Rifletti verticalmente',
  'Flip horizontally': 'Rifletti orizzontalmente',
  'Edit image': 'Modifica immagine',
  'Image options': 'Opzioni immagine',
  'Zoom in': 'Ingrandisci',
  'Zoom out': 'Rimpicciolisci',
  Crop: 'Taglia',
  Resize: 'Ridimensiona',
  Orientation: 'Orientamento',
  Brightness: 'Luminosit\u00e0',
  Sharpen: 'Contrasta',
  Contrast: 'Contrasto',
  'Color levels': 'Livelli colore',
  Gamma: 'Gamma',
  Invert: 'Inverti',
  Apply: 'Applica',
  Back: 'Indietro',
  'Insert date/time': 'Inserisci Data/Ora',
  'Date/time': 'Data/Ora',
  'Insert link': 'Inserisci il Link',
  'Insert/edit link': 'Inserisci/Modifica Link',
  'Text to display': 'Testo da Visualizzare',
  Url: 'Url',
  Target: 'Target',
  None: 'No',
  'New window': 'Nuova Finestra',
  'Remove link': 'Rimuovi link',
  Anchors: 'Anchors',
  Link: 'Collegamento',
  'Paste or type a link': 'Incolla o digita un collegamento',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?':
    "L'URL inserito sembra essere un indirizzo email. Vuoi aggiungere il prefisso necessario mailto:?",
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?':
    "L'URL inserito sembra essere un collegamento esterno. Vuoi aggiungere il prefisso necessario http://?",
  'Link list': 'Elenco link',
  'Insert video': 'Inserisci Video',
  'Insert/edit video': 'Inserisci/Modifica Video',
  'Insert/edit media': 'Inserisci/Modifica Media',
  'Alternative source': 'Alternativo',
  Poster: 'Anteprima',
  'Paste your embed code below:': "Incolla il codice d'incorporamento qui:",
  Embed: 'Incorporare',
  Media: 'Media',
  'Nonbreaking space': 'Spazio unificatore',
  'Page break': 'Interruzione di pagina',
  'Paste as text': 'incolla come testo',
  Preview: 'Anteprima',
  Print: 'Stampa',
  Save: 'Salva',
  Find: 'Trova',
  'Replace with': 'Sostituisci Con',
  Replace: 'Sostituisci',
  'Replace all': 'Sostituisci Tutto',
  Prev: 'Precedente',
  Next: 'Successivo',
  'Find and replace': 'Trova e Sostituisci',
  'Could not find the specified string.': 'Impossibile trovare la parola specifica.',
  'Match case': 'Maiuscole/Minuscole ',
  'Whole words': 'Parole Sbagliate',
  Spellcheck: 'Controllo ortografico',
  Ignore: 'Ignora',
  'Ignore all': 'Ignora Tutto',
  Finish: 'Termina',
  'Add to Dictionary': 'Aggiungi al Dizionario',
  'Insert table': 'Inserisci Tabella',
  'Table properties': 'Propiet\u00e0 della Tabella',
  'Delete table': 'Cancella Tabella',
  Cell: 'Cella',
  Row: 'Riga',
  Column: 'Colonna',
  'Cell properties': 'Propiet\u00e0 della Cella',
  'Merge cells': 'Unisci Cella',
  'Split cell': 'Dividi Cella',
  'Insert row before': 'Inserisci una Riga Prima',
  'Insert row after': 'Inserisci una Riga Dopo',
  'Delete row': 'Cancella Riga',
  'Row properties': 'Propriet\u00e0 della Riga',
  'Cut row': 'Taglia Riga',
  'Copy row': 'Copia Riga',
  'Paste row before': 'Incolla una Riga Prima',
  'Paste row after': 'Incolla una Riga Dopo',
  'Insert column before': 'Inserisci una Colonna Prima',
  'Insert column after': 'Inserisci una Colonna Dopo',
  'Delete column': 'Cancella Colonna',
  Cols: 'Colonne',
  Rows: 'Righe',
  Width: 'Larghezza',
  Height: 'Altezza',
  'Cell spacing': 'Spaziatura della Cella',
  'Cell padding': 'Padding della Cella',
  Caption: 'Didascalia',
  Left: 'Sinistra',
  Center: 'Centro',
  Right: 'Destra',
  'Cell type': 'Tipo di Cella',
  Scope: 'Campo',
  Alignment: 'Allineamento',
  'H Align': 'Allineamento H',
  'V Align': 'Allineamento V',
  Top: 'In alto',
  Middle: 'In mezzo',
  Bottom: 'In fondo',
  'Header cell': "cella d'intestazione",
  'Row group': 'Gruppo di Righe',
  'Column group': 'Gruppo di Colonne',
  'Row type': 'Tipo di Riga',
  Header: 'Header',
  Body: 'Body',
  Footer: 'Footer',
  'Border color': 'Colore bordo',
  'Insert template': 'Inserisci Template',
  Templates: 'Template',
  Template: 'Modello',
  'Text color': 'Colore Testo',
  'Background color': 'Colore Background',
  'Custom...': 'Personalizzato...',
  'Custom color': 'Colore personalizzato',
  'No color': 'Nessun colore',
  'Table of Contents': 'Tabella dei contenuti',
  'Show blocks': 'Mostra Blocchi',
  'Show invisible characters': 'Mostra Caratteri Invisibili',
  'Words: {0}': 'Parole: {0}',
  '{0} words': '{0} parole',
  File: 'File',
  Edit: 'Modifica',
  Insert: 'Inserisci',
  View: 'Visualiza',
  Format: 'Formato',
  Table: 'Tabella',
  Tools: 'Strumenti',
  'Powered by {0}': 'Fornito da {0}',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help':
    "Rich Text Area. Premi ALT-F9 per il men\u00f9. Premi ALT-F10 per la barra degli strumenti. Premi ALT-0 per l'aiuto.",
});
